var WDN = WDN || {};

if (typeof WDN.Search === "undefined") {
  WDN.Search = (function () {
    class WDNSearch extends HTMLElement {
      constructor() {
        super();
      }

      serialize() {
        return Array.from(new FormData(this.nodes.form), function (e) {
          return e.map(encodeURIComponent).join("=");
        }).join("&");
      }

      assign_search_params() {
        this.search_params = this.get_search_params();
      }

      assign_search_recommendations() {
        this.nodes.recommendations.forEach(function (recommendation) {
          var value = recommendation.getAttribute("data-value").toLowerCase();
          this.search_recommendations.push(value);
        }, this);
      }

      assign_search_history() {
        var session_storage = sessionStorage.getItem(this.config.storage_key);

        if (session_storage) {
          var session_storage_json = JSON.parse(session_storage);
        }

        this.search_history = session_storage_json || [];
      }

      get_request_url() {
        var search_params = this.get_search_params();
        return this.config.url + "?" + search_params.toString();
      }

      get_search_params() {
        return new URLSearchParams(this.serialize());
      }

      set_layout(new_layout) {
        this.layout = new_layout;
        this.setAttribute("data-layout", new_layout);
      }

      set_input_state(new_state) {
        this.setAttribute("data-input-state", new_state);
        document.body.setAttribute("data-search-input", new_state);
      }

      render_results(content) {
        this.nodes.results_output.innerHTML = content;
        this.set_layout("results");
      }

      render_search_history() {
        if (!this.nodes.history_output) return;
        // empty container
        this.nodes.history_output.innerHTML = "";
        // render inside container
        this.search_history.forEach(function (result) {
          this.nodes.history_output.appendChild(this.template_history_result(result));
        }, this);
      }

      push_to_history(query) {
        // if no query or if query is alredy in recommendations
        if (!query || this.search_recommendations.indexOf(query) > -1) return;

        // handle query being in history -> remove from current position
        if (this.search_history.indexOf(query) > -1) {
          this.search_history.splice(this.search_history.indexOf(query), 1);
        }
        // set it as first position in array
        this.search_history.unshift(query);

        // getting rid of extra storage
        if (this.search_history.length >= this.config.storage_limit) {
          this.search_history.splice(this.config.storage_limit, 1);
        }

        // store data to session storage
        sessionStorage.setItem(this.config.storage_key, JSON.stringify(this.search_history));
      }

      template_history_result(result) {
        if (!"content" in document.createElement("template")) return result;
        var template_clone = this.templates.recommendation_item.content.cloneNode(true);

        var template_value = template_clone.querySelector("[data-value]");
        var template_title = template_clone.querySelector("[data-title]");

        template_value.setAttribute("data-value", result);

        template_title.innerHTML = result;

        return template_clone;
      }

      validate_request_results(sections) {
        var query = this.nodes.input.value.toLowerCase().trim();
        var content = [];

        // looping through sections and storing it in array
        for (var id in sections) {
          if (sections.hasOwnProperty(id)) {
            content.push(sections[id]);
          }
        }

        // converting array to string
        content = content.join("");
        var dom_parser = new DOMParser();
        var parsed_content = dom_parser.parseFromString(content, "text/html");
        var result_count_container = parsed_content.documentElement.querySelector("[data-result-count]");
        var result_count = parseInt(result_count_container.getAttribute("data-result-count"));

        // storing results
        this.search_results[query] = {
          content: content,
          result_count: result_count,
        };

        this.push_to_history(query);
        this.append_result_count(result_count);
        this.render_results(content);
      }

      send_request() {
        this.fetching(true);
        var url = this.get_request_url();
        fetch(url)
          .then(function (response) {
            return response.json();
          })
          .then(
            function (data) {
              this.validate_request_results(data);
              this.fetching(false);
            }.bind(this)
          )
          .catch(
            function () {
              this.fetching(false);
            }.bind(this)
          );
      }

      fetching(state) {
        this.is_fetching = state;
      }

      clear_search() {
        this.nodes.input.value = "";
        this.render_search_history();
        this.append_result_count(false);
        this.set_layout("default");
        this.set_input_state("default");
      }

      handle_form_submit(e) {
        e ? e.preventDefault() : "";
        this.handle_input_event();
      }

      append_result_count(count) {
        if (typeof count === "number") {
          this.setAttribute("data-result-count", count);
        } else {
          this.removeAttribute("data-result-count");
        }
      }

      handle_input_event() {
        var query = this.nodes.input.value.toLowerCase();
        if (query.length == 0) {
          this.clear_search();
          this.set_input_state("default"); // clearing the current input state
          return;
        }
        this.set_input_state("has-search");

        if (query.length < this.config.min_query_length || this.is_fetching) return;

        if (this.search_results.hasOwnProperty(query)) {
          this.push_to_history(query); // sets query in #1 position
          this.append_result_count(this.search_results[query].result_count);
          this.render_results(this.search_results[query].content);
        } else {
          this.send_request();
        }
      }

      handle_input_focus() {
        this.set_input_state("focused");
      }

      handle_input_focusout(e) {
        var state = "default";
        if (e.currentTarget.value.length > 0) {
          state = "has-search";
        }
        this.set_input_state(state);
      }

      handle_clear_event(e) {
        if (e.detail.id !== this.config.id) return;
        this.clear_search();
      }

      bind() {
        var debounced_input = WDN.Debounce(this.handle_input_event.bind(this), this.config.input_debounce);
        this.nodes.input.addEventListener("input", debounced_input);
        this.nodes.input.addEventListener("focus", this.handle_input_focus.bind(this));
        this.nodes.input.addEventListener("focusout", this.handle_input_focusout.bind(this));
        this.nodes.form.addEventListener("submit", this.handle_form_submit.bind(this));
        document.body.addEventListener("search:clear", this.handle_clear_event.bind(this));
      }

      configure() {
        this.nodes = {
          form: this.querySelector("form"),
          input: this.querySelector("[data-search-input]"),
          recommendations: this.querySelectorAll("wdn-search-recommendation"),
          results_output: this.querySelector("[data-search-results]"),
          history_output: this.querySelector("[data-search-history]"),
        };

        this.config = {
          id: this.getAttribute("data-id"),
          url: this.nodes.form.getAttribute("action"),
          min_query_length: parseInt(this.nodes.input.getAttribute("min")) || 3,
          storage_key: "search_history",
          storage_limit: 10,
          input_debounce: 260,
        };

        this.templates = {
          recommendation_item: this.querySelector("[data-recommendation-template]"),
        };

        this.search_params = {}; // will be populated on init

        this.search_results = {}; // will be populated on init

        this.search_history = {}; // will be populated on init

        this.search_recommendations = []; // will be populated on init

        this.layout = this.getAttribute("data-layout");
      }

      init() {
        this.configure();
        this.set_input_state("default");
        this.assign_search_recommendations();
        this.assign_search_history();
        this.render_search_history();
        this.assign_search_params();
        this.bind();
      }
    }

    class WDNSearchFragment extends HTMLElement {
      constructor() {
        super();
        this.id = this.getAttribute("data-id");
        this.wdn_search = document.querySelector("wdn-search[data-id='" + this.id + "']");
        this.scroll_container = this.wdn_search.querySelector("[data-searchdrawer-content]");
      }
    }

    class WDNSearchRecommendation extends WDNSearchFragment {
      constructor() {
        super();
      }

      handle_click() {
        this.wdn_search.nodes.input.value = this.value;
        this.wdn_search.handle_input_event();
      }

      bind() {
        this.addEventListener("click", this.handle_click.bind(this));
      }

      init() {
        if (!this.wdn_search) return;
        this.bind();
      }

      connectedCallback() {
        this.value = this.getAttribute("data-value");
        this.init();
      }
    }

    class WDNSearchPagination extends WDNSearchFragment {
      constructor() {
        super();
      }

      handle_fetch_error() {
        this.is_fetching = false;
      }

      handle_fetch_success(res) {
        this.is_fetching = false;
        this.scroll_container.scroll(0, 0);
        this.wdn_search.render_results(res);
      }

      handle_click() {
        if (this.is_fetching) return;
        fetch(this.url)
          .then(function (response) {
            return response.text();
          })
          .then(this.handle_fetch_success.bind(this))
          .catch(this.handle_fetch_error.bind(this));
        this.is_fetching = true;
      }

      bind() {
        this.addEventListener("click", this.handle_click.bind(this));
      }

      init() {
        if (!this.wdn_search) return;
        this.bind();
      }

      connectedCallback() {
        this.url = this.getAttribute("data-url");
        this.init();
      }
    }

    class WDNSearchClear extends WDNSearchFragment {
      constructor() {
        super();
      }

      handle_click() {
        this.wdn_search.clear_search();
      }

      bind() {
        this.addEventListener("click", this.handle_click.bind(this));
      }

      init() {
        if (!this.wdn_search) return;
        this.bind();
      }

      connectedCallback() {
        this.init();
      }
    }

    customElements.define("wdn-search-recommendation", WDNSearchRecommendation);
    customElements.define("wdn-search", WDNSearch);
    customElements.define("wdn-search-pagination", WDNSearchPagination);
    customElements.define("wdn-search-clear", WDNSearchClear);

    return WDNSearch;
  })();
}
